<template>
  <div>
    <Header
      :title="'面接情報'"
      data-test="header"
    />
    <div
      class="boss-admin-container clearfix"
    >
      <sidebar />
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from '@/components/templates/Header'
import Sidebar from '@/components/organisms/Sidebar'
import { mapActions } from 'vuex'

export default {
  components: {
    Sidebar,
    Header
  },
  async created () {
    await this.fetchInterviewMasters()
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ]),
    async fetchInterviewMasters () {
      const masters = [
        'arinashiLabels',
        'spis',
        'interviewAcceptableDigitalDocuments',
        'interviewSelectionPeriods',
        'interviewSteps',
        'interviewAvailableHours',
        'interviewAvailableDays',
        'interviewDressCodes',
        'interviewRequiredTimes',
        'genders',
        'positions',
        'generations',
        'interviewFlows',
        'interviewImportances',
        'interviewCheckpointCategories'
      ]
      await masters.forEach(element => {
        this.storeMaster(element)
      })
    }
  }
}
</script>
